import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31124 26464"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:451.069}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313139312">
        <path
          d="M29144 1380H1980c-117 0-213-95-213-213s96-213 213-213h27164c117 0 212 95 212 213s-95 213-212 213z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}
        />
        <path
          d="M1167 651c-284 0-516 232-516 516s232 515 516 515 516-231 516-515-232-516-516-516zm0 1457c-519 0-941-422-941-941s422-941 941-941c520-1 942 422 942 941s-422 941-942 941zM29957 651c-285 0-516 232-516 516s231 515 516 515c284 0 515-231 515-515s-231-516-515-516zm0 1457c-520 0-942-422-942-941s422-941 942-941c519-1 941 422 941 941s-422 941-941 941zM7174 1380h-38c-118 0-213-95-213-213s95-213 213-213h38c118 0 213 95 213 213s-95 213-213 213zM26359 25813h1835V1380h-1835v24433zm2261 426h-2687V954h2687v25285z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M26359 21854h-2687V5100c0-118 95-213 213-213 117 0 213 96 213 213v16328h1835V1380h-2048c-118 0-213-95-213-213s95-213 213-213h2474v20900z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M24098 18161h-2687V6307c0-118 95-213 213-213 117 0 213 95 213 213v11428h1835V5100c0-118 95-213 213-213 117 0 213 96 213 213v13061zM2743 25813h1835V1380H2743v24433zm2261 426H2317V954h2687v25285z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M7265 21854H4578V954h2474c118 0 213 95 213 213s-95 213-213 213H5004v20048h1835V5100c0-118 96-213 213-213 118 0 213 96 213 213v16754z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M9526 18161H6839V5100c0-118 96-213 213-213 118 0 213 96 213 213v12635h1835V6307c0-118 95-213 213-213 117 0 213 95 213 213v11854zM15562 5489c-2272 0-4412-432-6024-1214-1662-806-2577-1896-2577-3069v-45c4-118 103-210 220-207 118 4 210 102 206 220v32c0 1001 830 1955 2337 2686 1555 754 3629 1170 5838 1170s4282-416 5838-1170c1507-731 2337-1685 2337-2686 0-11 0-22-1-33-3-117 89-215 207-219h6c116 0 210 91 213 207 1 14 1 30 1 45 0 1173-915 2263-2577 3069-1613 782-3753 1214-6024 1214z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M15562 3281c-1753 0-3423-295-4705-832-1234-516-1586-1036-1644-1135l-62-106 61-107c9-17 20-35 36-57 67-96 201-119 297-51 60 42 92 110 90 179 125 151 492 510 1386 884 1231 515 2844 799 4541 799s3310-284 4540-799c894-374 1262-733 1386-884-1-69 31-137 91-179 96-68 229-45 297 52 15 22 27 39 36 56l60 107-61 106c-59 98-410 619-1644 1135-1282 537-2953 832-4705 832z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
        <path
          d="M15562 7541c-2577 0-5034-504-6920-1419-1046-508-1893-1128-2517-1843-796-914-1217-1976-1217-3073 0-15 0-31 1-45 4-118 101-210 219-207 118 4 210 102 207 220-1 10-1 21-1 32 0 992 385 1958 1113 2793 585 672 1386 1257 2380 1739 1830 888 4222 1377 6735 1377 2512 0 4904-489 6734-1377 994-482 1796-1067 2381-1739 728-835 1112-1801 1112-2793v-33c-4-117 89-215 207-219h6c115 0 210 91 213 207 1 14 0 30 0 45 1 1096-421 2159-1216 3073-625 715-1471 1335-2517 1843-1887 915-4345 1419-6920 1419z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 451.069,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
